import { v4 as uuidv4 } from "uuid";
export class PageManagerModel {
    constructor() {
        this.id = uuidv4();
        this.text = "";
        this.displayOrder = 0;
        this.children = null;
        this.state = null;
    }
}
export class PageElementModel {
    constructor() {
        this.id = uuidv4();
        this.pageId = uuidv4();
        this.text = "";
        this.description = "";
        this.displayOrder = 0;
        this.state = null;
    }
}
export class SelectionStateModel {
}
export class PageManager extends PageManagerModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
export class PageElement extends PageElementModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
